



















import { Component, Vue } from 'vue-property-decorator';
import MsisdnBalances from "@/components/MsisdnBalances.vue";
import MessageWithHistory from "@/components/MessageWithHistory.vue";
import MsisdnLoan from "@/components/MsisdnLoan.vue";
import TransactionsTable from "@/components/TransactionsTable.vue";
import {TransactionPreview} from "@/model/transaction-preview";
import {TransactionFilter} from "@/model/transaction-filter";
import {transactionService} from "@/services/transaction";
import FraudCaseTable from "@/components/FraudCaseTable.vue";
import {CriteriaType, FilterCriteria} from "@/model/filter-criteria";
import TransactionsCriteriaPicker from "@/components/TransactionsCriteriaPicker.vue";
import {TransactionBalancesDto} from "@/model/balance";
import {supportService} from "@/services/support";

@Component({
  components: {
    TransactionsCriteriaPicker, MsisdnBalances}
})
export default class TransactionAnalysis extends Vue {

  criteriaOptions: CriteriaType[] =  [
    CriteriaType.TRANSACTION_ID
  ];

  overlay = false;

  transactionBalances: TransactionBalancesDto | null = null

  async refreshRelated(criterias: FilterCriteria[]) {
    console.log('Hello')
    this.overlay = true;
    const txId = criterias.find( c => c.type === CriteriaType.TRANSACTION_ID)?.value
    console.log(txId)
    if(txId) {
      this.transactionBalances = await supportService.getBalancesForTransaction(txId);
    } else {
      this.transactionBalances = null;
    }
    this.overlay = false;
  }

}
